<script lang="ts">
  import type { Operator } from "@/src/types/components/operators/Operator";
  import Icons from "$lib/main/components/Icons.svelte";
  import Translate from "../../helpers/Translate.svelte";
  import { getOperatorLogo } from "$lib/common/helpers/image";
  import { project, postData } from "$lib/services/store";
  import Breadcrumbs from "$lib/main/components/Breadcrumbs.svelte";
  import { page } from "$app/stores";
  import type { IntroProps } from "@/src/types/components/Intro";

  type PostDataType = {
    user?: { full_name?: string };
    approved?: { full_name?: string };
    [key: string]: any;
  };

  export let props: IntroProps;
  export let operator: Operator | undefined;
  export let crm: boolean = false;
  export let crmText: string = "";

  let cardContent: HTMLElement;

  $: typedPostData = $postData as PostDataType;

  const tournamentRoute = $project.settings.tournamentsUrl ?? "turneringar";
  $: isTournamentsRoute = $page.url.pathname.includes(`/${tournamentRoute}`);
  $: isHomePage = $page.url.pathname === "/" || $page.url.pathname === "";
</script>

<div
    class="bg-brand-light text-white m-0 py-4 content-grid"
    id="block-intro"
>
  <div class="grid grid-cols-1 {props.image?.url ? 'lg:grid-cols-[66.6666%_6.3333%_25%]' : ''}">
    <div class="lg:col-start-1 lg:col-end-2">
      <div class="flex items-center gap-2.5">
        {#if operator}
          <div
              class="flex items-center justify-center w-[50px] h-[50px] bg-white rounded-lg"
              style="background-color: rgba({operator?.visuals?.[$project.key][$project.settings.market].primary_color})">
            <img
                class="max-w-[50px] max-h-[50px]"
                alt={operator?.name_lower + " logo"}
                src={getOperatorLogo($project, operator?.logo)} />
          </div>
        {/if}
        <h1 class="m-0">{props.header ? props.header : ""}</h1>
      </div>
      {#if operator}
        <div class="flex items-center justify-end gap-1 text-base font-bold leading-[20.8px]">
          {#if operator?.rating[$project.key][$project.settings.market]["closed"]}
            <div class="py-1.5 px-2.5 gap-1 rounded-lg bg-[#ebebeb] text-black text-base font-bold leading-[20.8px]">
              <Translate text="Casino closed" />
            </div>
          {:else if operator?.rating[$project.key][$project.settings.market]["license"]}
            <Translate text="English license" />
            <div class="flex items-center justify-center bg-white w-3.5 h-3.5 min-w-[14px] min-h-[14px] rounded-full">
              <Icons name="fire" width="10px" height="10px"></Icons>
            </div>
          {:else}
            <Translate text="No English license" />
            <div class="flex items-center justify-center bg-white w-3.5 h-3.5 min-w-[14px] min-h-[14px] rounded-full">
              <Icons name="cross" width="10px" height="10px"></Icons>
            </div>
          {/if}
        </div>
      {/if}
      <div class="mt-2.5 mb-2.5">
        <div
          class="text-nav font-light overflow-visible [&>p>a]:text-white [&>p>a:hover]:underline"
          bind:this={cardContent}
        >
          {@html props.content ? props.content : ""}
        </div>
      </div>

      <div class="flex flex-col md:flex-row w-full gap-2 md:gap-3 mt-2.5">
        {#if typedPostData?.user?.full_name}
          <p class="flex items-center gap-2 m-0 text-sm font-bold leading-[18.2px]">
            <Translate text="Written by" />
            {typedPostData.user.full_name}
            <Icons name="verified"></Icons>
          </p>
        {/if}
        {#if typedPostData?.approved?.full_name}
          <p class="flex items-center gap-2 m-0 text-sm font-bold leading-[18.2px]">
            <Translate text="Approved by" />
            {typedPostData.approved.full_name}
            <Icons name="verified"></Icons>
          </p>
        {/if}
      </div>
    </div>

    {#if props.image?.url}
      <figure class="order-first lg:order-none lg:col-start-3 lg:col-end-4 lg:row-start-1 lg:self-center lg:pb-0 m-0 mx-auto">
        <img
            src={$project.data?.imageFolders?.media + props.image.url}
            alt={props.header || "Intro image"}
            width="500"
            height="500"
            decoding="auto"
            class="h-40 w-auto"
        />
      </figure>
    {/if}
  </div>

</div>
{#if !isTournamentsRoute && !isHomePage}
  <Breadcrumbs />
{/if}

<style>
  :global(.text-nav p) {
    margin: 0;
  }
</style>
